import API from '../../../../../services/api';

export const API_USERS = {
    getUsers: async (page = null, search = null) => {
        const pagination = page !== null ? '?page=' + page : '';
        const searcher = search !== null && page !== null ? '&' + search : search !== null ? '?' + search : '';
        return await API.get('/users' + pagination + searcher).then(res => res.data);
    },
    getUser: async (userId) => {
        return await API.get('/users/' + userId).then(res => res.data);
    },
    newUser: async (user) => {
        return API.post('/users', user).then(res => res.data);
    },
    userChangePassword: async (user) => {
        return API.post('/users/' + user.id + '/change_password', user).then(res => res.data);
    },
    enableDisableUser: async (user) => {
        return API.post('/users/estado', user).then(res => res.data);
    },
    updateUser: async (user) => {
        return API.put('/users/' + user.id, user).then(res => res.data);
    },
    reportCrmProblem: async (problema) => {
        return API.post('/users/reportar-problema', problema).then(res => res.data);
    }
}